<template>
  <div id="app">
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <main :style="{ backgroundColor: empresa.cor_site_clara }">
      <div>
        <p id="p1">
          Compliance
        </p>
        <p id="p2">
          Acompanhar denúncia
        </p>
      </div>

      <v-card class="box-general">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label :style="{ color: empresa.cor_site_escura }">Digite o protocolo da denúncia que deseja acompanhar:</label>
              <input 
                type="text"
                class="form-control"
                v-model="protocolo"
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="button-area flex justify-content-center align-items-center">
            <button :style="{ backgroundColor: empresa.cor_site_escura }" class="btn_1 medium" type="button" @click="buscaDenuncia">Pesquisar</button>
          </div>
        </div>
        <div v-if="eventos.length >= 1" style="width: 100%">
          <div class="flex justify-content-center">
            <div class="protocol-area" :style="{ backgroundColor: empresa.cor_site_escura }">
              {{ denuncia.protocolo }}
            </div>
          </div>
          <p class="font-weight-bold">Status atual: {{ denuncia.status_atual }}</p>
          <div class="col-md-12">
            <div class="form-group">
              <label>Eventos</label>
              <v-expansion-panel>
                <v-expansion-panel-content
                  v-for="item in eventos"
                  :key="item.id"
                >
                  <template v-slot:header>
                    <div class="eventTitle">{{ padronizaDataHora(item.created_at) }}</div>
                    <div class="eventTitle">{{ item.titulo }}</div>
                  </template>
                  <v-card>
                    <v-img v-if="item.arquivo_evento_denuncia"
                      :src=baseUrl+item.arquivo_evento_denuncia
                    ></v-img>
                    <v-card-text class="ml-2">{{item.descricao}}</v-card-text>
                    <div class="formPostEvento">
                      <input
                      class="form-control"
                      v-model="evento.titulo"
                      placeholder="Título">
                      <textarea
                        class="form-control"
                        v-model="evento.descricao"
                        placeholder="Descrição"
                        rows="4"
                      ></textarea>
                      <input
                        @change="sendFile"
                        ref="addImagem"
                        type="file"
                        class="form-control"
                      />
                      <button :style="{ backgroundColor: empresa.cor_site_escura }" class="btn_1 medium my-3" @click="postEvento">Enviar</button>
                    </div>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </div>
          </div>
        </div>
      </v-card>
    </main>
  </div>
</template>

<script>
import funcoesGerais from "@/assets/js/funcoes.js";
import { alerta, tratamento_requisicao, ajax } from "../../utils/util";
import axios from "axios";
export default {
  mixins: [funcoesGerais],
	data() {
		return {
      isLoading: false,
      empresa: {
        arquivo_logo: '',
        cor_site_escura: '',
        cor_site_media: '',
        cor_site_clara: '',
      },
      protocolo: '',
      denuncia: {},
      eventos: [],
      baseUrl: '',
      evento: {
        titulo: '',
        descricao: '',
        arquivo_evento_denuncia: '',
        denuncias_id: null
      },
      status: [
        { status:'Recebida', id: 1},
        { status:'Em Análise', id: 2},
        { status:'Finalizada', id: 3},
        { status:'Procedente', id: 4},
        { status:'Improcedente', id: 5},
        { status:'Inconclusiva', id: 6}
      ]
		};
	},

  created() {
    this.isLoading = true
    let subUrl = window.location.hostname
    subUrl = subUrl.split('.')

    axios.get(`show_by_subdominio/${subUrl[0]}`)
      .then((res) => {
        this.isLoading = false
        this.empresa = res.data
      }, err => {
        this.isLoading = false
        tratamento_requisicao(err);
      })
  },

	methods: {
    sendFile(event) {
      this.evento.arquivo_evento_denuncia = event.target.files[0];
    },
    buscaDenuncia() {
      axios.get(`denuncias_by_protocolo/${this.protocolo}`)
        .then((res) => {
          this.denuncia = res.data
          this.eventos = res.data.eventos_denuncias
          this.baseUrl = axios.defaults.baseURL.slice(0, -3) + 'arquivos_eventos_denuncia/'
          let temp = this.status.find(a => a.id === this.denuncia.status_atual);
          if (temp) {
            this.denuncia.status_atual = temp.status;
          }
          this.isLoading = false

        }, err => {
          this.isLoading = false
          tratamento_requisicao(err);
        })
    },
    postEvento() {
      let self = this;

      if(self.evento.titulo && self.evento.descricao !== '') {
        self.isLoading = true;
        let objRequest = new FormData();

        objRequest.append('titulo', self.evento.titulo);
        objRequest.append('descricao', self.evento.descricao);
        objRequest.append('denuncias_id', self.denuncia.id);

        if(self.evento.arquivo_evento_denuncia)
          objRequest.append('arquivo_evento_denuncia', self.evento.arquivo_evento_denuncia);
        
        ajax("post", "eventos_denuncias", objRequest)
          .then(() => {
            self.isLoading = false;
            self.evento = {};
            this.buscaDenuncia();
          })
          .catch(error => {
            self.isLoading = false;
            tratamento_requisicao(error);
          });
      } else {
        alerta('warning', 'Atenção', 'Preencha todos os campos');
      }
    }
	}
};
</script>

<style scoped>
#app {
  display: flex;
  flex-direction: column;
}

main {
  display: flex !important;
  flex: 1;
  justify-content: space-evenly;
  align-items: center;
  text-align: center;
  padding: 3vh;
}

label {
  display: flex;
  font-weight: bold;
  font-size: 1em;
  margin-bottom: 2px;
}

button {
  display: flex;
  justify-content: center;
  align-items: center;
}

.box-general {
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  padding: 3vh;
  border-radius: 10px;
}

#p1 {
  color: #ffffff;
  font-size: 3em;
  font-weight: bold;
  margin-bottom: 2vh;
}

#p2 {
  color: #ffffff;
  font-size: 2.5em;
  font-weight: normal;
  line-height: 1;
}

.formPostEvento {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;
  padding: 10px;
  background-color: #bdbdbd;
  border-radius: 5px !important;
}

.eventTitle {
  font-weight: bold;
  font-size: 14px !important;
}

.protocol-area {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2em;
  width: 300px;
  margin: 10px;
  border-radius: 5px;
  font-size: 1.5em;
  color: white;
}

@media (max-width: 374px) {
  #p1 {
    font-size: 2rem;
  }

  #p2 {
    font-size: 1.5rem;
  }

  .box-general {
    width: 90%;
  }
}

@media (min-width: 375px) and (max-width: 576px) {
  #p1 {
    font-size: 3.5vh;
  }

  #p2 {
    font-size: 2.5vh;
  }

  .box-general {
    width: 90%;
  }
}

@media (min-width: 577px) and (max-width: 768px) {
  #p1 {
    font-size: 4vh;
  }

  #p2 {
    font-size: 3vh;
  }

  .box-general {
    width: 80%;
  }
}

@media (min-width: 769px) and (max-width: 992px) {
  #p1 {
    font-size: 4.5vh;
  }

  #p2 {
    font-size: 3.8vh;
  }

  .box-general {
    width: 75%;
  }
}

@media (min-width: 993px) and (max-width: 1200px) {
  #p1 {
    font-size: 4.8vh;
  }

  #p2 {
    font-size: 4vh;
  }

  .box-general {
    width: 60%;
  }
}

@media (max-width: 900px) {
  main {
    flex-direction: column;
  }
}
</style>